import React, { useState, useEffect } from 'react';
import { API_BASE_URL } from "../../config";
import { Search, Filter } from 'lucide-react';

const ViewFeedbackPage = () => {
    const [feedbacks, setFeedbacks] = useState([]);
    const server_url = API_BASE_URL;

    // Filter state
    const [search, setSearch] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');

    useEffect(() => {
        const accessToken = localStorage.getItem('accessToken');

        const fetchFeedback = async () => {
            try {
                const response = await fetch(server_url + '/admin/view_feedback', {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${accessToken}`,
                    },
                });
                if (response.ok) {
                    const data = await response.json();
                    setFeedbacks(data);
                } else {
                    console.error('Failed to fetch feedback');
                }
            } catch (error) {
                console.error('Error fetching feedback:', error);
            }
        };

        fetchFeedback();
    }, []);

    // Client-side filtering: search across Name/Email/Message, plus Submitted At date range
    const filteredFeedbacks = feedbacks.filter((feedback) => {
        const matchesSearch = !search ||
            feedback.name?.toLowerCase().includes(search.toLowerCase()) ||
            feedback.email?.toLowerCase().includes(search.toLowerCase()) ||
            feedback.message?.toLowerCase().includes(search.toLowerCase());

        const submittedAt = feedback.submitted_at ? new Date(feedback.submitted_at) : null;
        const matchesStartDate = !startDate ||
            (submittedAt && submittedAt >= new Date(startDate));
        const matchesEndDate = !endDate ||
            (submittedAt && submittedAt <= new Date(`${endDate}T23:59:59`));

        return matchesSearch && matchesStartDate && matchesEndDate;
    });

    const clearFilters = () => {
        setSearch('');
        setStartDate('');
        setEndDate('');
    };

    return (
        <>
            <div className="flex flex-col items-center justify-center mt-8">
                <div className="w-full p-6 bg-[#F7F7F7] rounded-xl shadow-md">
                    <p className="text-2xl font-semibold text-[#333]">User Feedback</p>

                    {/* Filter Section - matches curriculum/LessonPlanManagement.js filter-bar convention */}
                    <div className="mt-6 bg-white rounded-xl shadow-sm border border-gray-200 p-5">
                        <div className="flex items-center gap-2 mb-4">
                            <Filter className="w-5 h-5 text-[#D67C2C]" />
                            <h3 className="font-semibold text-gray-800">Filters</h3>
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">Search</label>
                                <div className="relative">
                                    <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
                                    <input
                                        type="text"
                                        value={search}
                                        onChange={(e) => setSearch(e.target.value)}
                                        placeholder="Search by name, email, or message..."
                                        className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#D67C2C] focus:border-transparent"
                                    />
                                </div>
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">Submitted From</label>
                                <input
                                    type="date"
                                    value={startDate}
                                    onChange={(e) => setStartDate(e.target.value)}
                                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#D67C2C] focus:border-transparent"
                                />
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">Submitted To</label>
                                <input
                                    type="date"
                                    value={endDate}
                                    onChange={(e) => setEndDate(e.target.value)}
                                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#D67C2C] focus:border-transparent"
                                />
                            </div>
                        </div>
                        {(search || startDate || endDate) && (
                            <button
                                onClick={clearFilters}
                                className="mt-3 text-sm text-[#D67C2C] hover:underline font-medium"
                            >
                                Clear filters
                            </button>
                        )}
                    </div>

                    <table className="mt-6 w-full table-auto bg-white rounded-xl shadow-sm">
                        <thead className="bg-[#EFEFEF]">
                            <tr>
                                <th className="py-2 px-4 text-left">Name</th>
                                <th className="py-2 px-4 text-left">Email</th>
                                <th className="py-2 px-4 text-left">Message</th>
                                <th className="py-2 px-4 text-left">Submitted At</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredFeedbacks.map((feedback, index) => (
                                <tr key={index}>
                                    <td className="py-2 px-4">{feedback.name}</td>
                                    <td className="py-2 px-4">{feedback.email}</td>
                                    <td className="py-2 px-4">{feedback.message}</td>
                                    <td className="py-2 px-4">{new Date(feedback.submitted_at).toLocaleString()}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
};

export default ViewFeedbackPage;
